import { render, staticRenderFns } from "./OrderInfo.vue?vue&type=template&id=5ffe5dd4&scoped=true"
import script from "./OrderInfo.vue?vue&type=script&lang=ts"
export * from "./OrderInfo.vue?vue&type=script&lang=ts"
import style0 from "./OrderInfo.vue?vue&type=style&index=0&id=5ffe5dd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffe5dd4",
  null
  
)

export default component.exports